import { useExperienceMasterDataApi } from "@/composables/useExperienceMasterDataApi";
import { useQuery } from "@tanstack/vue-query";

export function useMarketsMasterdataQuery() {
  const experienceMasterDataApi = useExperienceMasterDataApi();
  return useQuery({
    queryKey: ["markets-masterdata"],
    queryFn: () => experienceMasterDataApi.getMarkets(),
    select: ({ data }) => data,
  });
}
